import * as React from 'react';
import type { ButtonHTMLAttributes } from 'react';

import { chakra, useRecipe } from '@chakra-ui/react';

import { navigationButtonRecipe } from './theme';

export interface NavigationButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'aria-label' | 'children'
> {
  'aria-label': string;
  children: React.ReactNode;
  size?: 'sm' | 'md';
}

const StyledNavigationButton = chakra('button');

export function NavigationButton({
  children,
  size = 'md',
  disabled,
  type = 'button',
  ...rest
}: NavigationButtonProps) {
  const recipe = useRecipe({ recipe: navigationButtonRecipe });
  const styles = recipe({ size });

  return (
    <StyledNavigationButton
      type={type}
      css={[styles['@layer recipes']]}
      disabled={disabled}
      {...rest}
    >
      {children}
    </StyledNavigationButton>
  );
}
